'use client';

import { useState, useEffect } from 'react';
import CustomTable from '../../components/CustomTable';
import { ModalAlert } from '@/components/ModalStyled/Modal';

import { HStack, Box, Input, Button, Text } from '@chakra-ui/react';
import { FaBoxOpen } from 'react-icons/fa';
import { BoxTitle } from '@/components/BoxTitle';
import ModalRetorno from '../../components/ModalRetorno';

interface TableProps {
  headers: any;
  onDelete: (selectedData: any[]) => void;
  dados: any[];
  valoPesquisa: string;
}

export default function TabelaLocalidade({ headers, onDelete, dados, valoPesquisa }: TableProps) {
  const [tableData, setTableData] = useState(dados);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newLocalidade, setNewLocalidade] = useState('');
  const [filteredData, setFilteredData] = useState(dados);

  // Estados para o ModalRetorno
  const [modalRetornoOpen, setModalRetornoOpen] = useState(false);
  const [mensagemRetorno, setMensagemRetorno] = useState('');
  const [tipoRetorno, setTipoRetorno] = useState<'sucesso' | 'erro'>('sucesso');

  useEffect(() => {
    setTableData(dados);
    setFilteredData(dados);
  }, [dados]);

  useEffect(() => {
    if (valoPesquisa.trim() === '') {
      setFilteredData(tableData);
    } else {
      const filtered = tableData.filter((item) =>
        Object.values(item).some((value) =>
          String(value).toLowerCase().includes(valoPesquisa.toLowerCase())
        )
      );
      setFilteredData(filtered);
    }
  }, [valoPesquisa, tableData]);

  const handleDeleteRecords = (selectedData: any[]) => {
    const selectedIds = selectedData.map(item => item.id);
    const newData = tableData.filter(item => !selectedIds.includes(item.id));
    setTableData(newData);
    onDelete(selectedData);
    setMensagemRetorno('Localidades excluídas com sucesso!');
    setTipoRetorno('sucesso');
    setModalRetornoOpen(true);
  };

  const handleDataChange = (newData: any[]) => {
    setTableData(newData);
  };

  const handleAddLocalidade = () => {
    if (newLocalidade.trim() !== '') {
      setTableData(prevData => [
        ...prevData,
        { id: prevData.length + 1, localidade: newLocalidade, ativo: true },
      ]);
      setNewLocalidade('');
      setIsModalOpen(false);
      setMensagemRetorno('Localidade adicionada com sucesso!');
      setTipoRetorno('sucesso');
      setModalRetornoOpen(true);
    }
  };

  return (
    <>
      <CustomTable
        headers={headers}
        data={tableData}
        searchValue={valoPesquisa}
        onDelete={handleDeleteRecords}
        onAdd={() => setIsModalOpen(true)}
        onDataChange={handleDataChange}
        addButtonLabel="Adicionar"
        deleteButtonLabel="Excluir"
        showActions={true}
      />

      <ModalAlert
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={
          <Text fontSize="lg" ml={2}>
            Adicionar Localidade
          </Text>
        }
        body={
          <HStack mt={3}>
            <BoxTitle title="Localidade">
              <Input
                placeholder="Adicione uma Localidade"
                value={newLocalidade}
                onChange={(e) => setNewLocalidade(e.target.value)}
              />
            </BoxTitle>
          </HStack>
        }
        footer={
          <Button colorScheme="blue" onClick={handleAddLocalidade}>
            Confirmar
          </Button>
        }
      />

      <ModalRetorno
        isOpen={modalRetornoOpen}
        onClose={() => setModalRetornoOpen(false)}
        mensagem={mensagemRetorno}
        tipo={tipoRetorno}
      />
    </>
  );
}
